import { FAQ, FAQSection } from '@/types/faq.types';

/**
 * Converts a FAQ object to plain text format for sending to the AI as context
 */
export const faqToText = (faq: FAQ): string => {
    const lines: string[] = [];

    // Add the main question/title
    lines.push(`Question: ${faq.h1}`);
    lines.push('');

    // Convert sections to text
    const sectionToText = (section: FAQSection, indent: string = ''): void => {
        lines.push(`${indent}${section.heading}`);

        if (section.content) {
            lines.push(`${indent}${section.content}`);
        }

        if (section.listItems && section.listItems.length > 0) {
            section.listItems.forEach(item => {
                lines.push(`${indent}• ${item}`);
            });
        }

        if (section.subsections && section.subsections.length > 0) {
            section.subsections.forEach(sub => {
                sectionToText(sub, indent + '  ');
            });
        }

        lines.push('');
    };

    faq.sections.forEach(section => sectionToText(section));

    // Add CTA context
    if (faq.ctaText) {
        lines.push(`The user was encouraged to: ${faq.ctaText}`);
    }

    return lines.join('\n');
};

/**
 * Creates a context prefix for the AI when user asks a follow-up question on a FAQ page
 */
export const createFAQContext = (faq: FAQ, isFirstMessage: boolean): string => {
    if (!isFirstMessage) {
        return '';
    }

    const faqContent = faqToText(faq);

    return `[CONTEXT: The user is on a FAQ page about "${faq.h1}". They have just read the following information and are now asking a follow-up question. Please provide helpful, relevant responses that build on this context.

--- FAQ CONTENT START ---
${faqContent}
--- FAQ CONTENT END ---

User's follow-up question:]

`;
};
